export default class DateFormats {
  static US = "MM/DD/YYYY";

  static EU = "DD.MM.YYYY";

  static BASE_PARSE = [
    "D MMM YYYY",
    "D MMMM YYYY",
    "D-M-YYYY",
    "D-MM-YYYY",
    "D.MM.YYYY",
    "D/M/YYYY",
    "D/MM/YYYY",
    "DD - M - YYYY",
    "DD - MM - YY",
    "DD - MM - YYYY",
    "DD - MMM - YYYY",
    "DD MMM YYYY",
    "DD MMMM YYYY",
    "DD-M-YYYY",
    "DD-MM-YY",
    "DD-MM-YYYY",
    "DD-MMM-YYYY",
    "DD. MM. YYYY",
    "DD.MM.YYYY",
    "DD/M/YYYY",
    "DD/MM/YYYY",
    "Dth MMMM YYYY",
    "Dth of MMMM, YYYY",
    "M - D - YYYY",
    "M - DD - YYYY",
    "M-D-YYYY",
    "M-DD-YYYY",
    "MM - D - YYYY",
    "MM - DD - YYYY",
    "MM-D-YYYY",
    "MM-DD-YYYY",
    "MMM D, YYYY",
    "MMM DD, YYYY",
    "MMMM D YYYY",
    "MMMM D, YYYY",
    "MMMM DD YYYY",
    "MMMM DD, YYYY",
    "YYYY - MM - DD",
    "YYYY-MM-DD"
  ];

  static US_PARSE = [
    "M/D/YYYY",
    "M/DD/YYYY",
    "MM / DD / YYYY",
    "MM/D/YYYY",
    "MM/DD/YYYY"
  ];

  static CA_PARSE = [
    "YY - MM - DD",
    "YY-MM-DD"
  ];
}
